import { render } from "./GbpPaymentButton.vue?vue&type=template&id=708d8db0"
import script from "./GbpPaymentButton.vue?vue&type=script&lang=js"
export * from "./GbpPaymentButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__